<template>
  <div class="bcWarp">
    <div class="inner">
      <div class="title">
        <img src="https://cdn1.zygames.com/qqsm/Public/img/version/xstm.png" />
      </div>
      <h2>幸运靶场</h2>
      <ul class="bc">
        <li
          v-for="(item,index) in bcList"
          :key="index"
        >
          <!-- <img :src="getImg(item,'bc')" alt="" > -->
          <img :src="'//cdn1.zygames.com/qqsm/t1/s/'+item.bcId+'.png'" alt="" >

          <p class="dates">{{bcData.Date}}</p>
          <!-- <p :class="item.bcType=='钻石靶场'?'names zsbc':'names'">{{item.bcname}}</p> -->
          <p :class="item.bcname.length>20?'names zsbc':'names'">{{item.bcname}}</p>
        </li>
      </ul>
      <!--jx2 jx3 jx4-->
      <dl class="jx jx3">
        <dd
          v-for="(item,index) in jxboxList"
          :key="index"
        >
          <!-- <img :src="getImg(item,'jx')" alt="" > -->
          <img :src="'//cdn1.zygames.com/qqsm/t1/s/'+item.jxId+'.png'" alt="" >
          <p>{{item.jxname}}</p>
        </dd>

        <dt class="jx-title">军需补给箱</dt>
        <dt class="jx-date">{{jxData.Date}}</dt>
      </dl>
    </div>

  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "versionBc",
  data() {
    return {
      // bc=>靶场 jx=>军需  **每次更新只需换下面数据** ImgSrc为道具ID，请先在后台添加好幸运靶场和军需补给箱数据后，按照其ID再来配置这里...
      // bcImgMap: Object.freeze([{ name: "传承-大地撕裂者 Mk.6（时限）概率翻倍", src: "6587" }]),
      // jxImgMap: Object.freeze([{ name: "死亡之翼时空箱（稀有）", src: "88045" }]),
      bcList: [],
      jxboxList: [],
    }
  },
  computed: {
    ...mapGetters(["bcData", "jxData"])
  },
  created() {
    // console.log("bc_created");
    var bcurl = 'https://passport.zygames.com/Banner/GetMagicBoxes?id='+this.bcData.rangeListID;
    this.$jsonp(bcurl,{
      callbackQuery: 'jsonpcallback', // jsonp key //请求传递参数 1
      callbackName: 'jsonp' // jsonp key //请求传递参数 2
    })
    .then(res => {
          // this.bcDataJsonp = res.Data.MagicBox.filter(item => {
          //   return item.Type === '幸运靶场';
          //     console.log(hotMovie);
          // }).map(item => {
          //   return {
          //     boxId:item.Id,
          //     boxStartTime:moment(item.StartTime).utc(8).format('YYYY年M月D日')
          //   }
          // })
          // console.log(this.bcDataJsonp[0].boxStartTime);
          // var boxid = this.bcDataJsonp[0].boxId;
          var boxid = this.bcData.rangeListID;
          this.$jsonp(bcurl,{
              callbackQuery: 'jsonpcallback', // jsonp key //请求传递参数 1
              callbackName: 'jsonp' // jsonp key //请求传递参数 2
          })
          .then(jsonp => {
              this.bcList = jsonp.Data.MagicBoxItems.filter(databc => {
                return databc.MagicBoxId === boxid
              }).map(databc => {
                return {
                  bcname: databc.Name,
                  bcId: databc.Code,
                  bcType: databc.Type
                }
              })
              // console.log(this.boxList);
          }).catch(err => {
            // console.log(err)
          })
    }).catch(error => {
      // console.log(error)
    });
    //this.getSelect()



    var jxurl = 'https://passport.zygames.com/Banner/GetMagicBoxes?id='+this.jxData.jxDataID;
    // console.log(this.jxData.jxDataID)
    this.$jsonp(jxurl,{
      callbackQuery: 'jsonpcallback', // jsonp key //请求传递参数 1
      callbackName: 'jsonpjx' // jsonp key //请求传递参数 2
    })
    .then(res => {
          var jxboxid = this.jxData.jxDataID;
          this.$jsonp(jxurl,{
              callbackQuery: 'jsonpcallback', // jsonp key //请求传递参数 1
              callbackName: 'jsonpjx' // jsonp key //请求传递参数 2
          })
          .then(jsonpjx => {
              this.jxboxList = jsonpjx.Data.MagicBoxItems.filter(datajx => {
                return datajx.MagicBoxId === jxboxid
              }).map(datajx => {
                return {
                  jxname: datajx.Name,
                  jxId: datajx.Code
                }
              })
              // console.log(this.boxList);
          }).catch(err => {
            // console.log(err)
          })
    }).catch(error => {
      // console.log(error)
    });
  },
  mounted() {
    // console.log("bc_mounted");
  },
  methods: {
    getImg(name, type) {
      var src = "",
          searchArr = [];
      if (type === "bc") {
          searchArr = this.bcImgMap;
      } else if (type === "jx") {
          searchArr = this.jxImgMap;
      }
      searchArr.forEach(function(val) {
          if (name.indexOf(val.name) !== -1) {
              src = val.src;
          }
      });

      if (!src) {
        // console.log(name);
      } else {
        // return require("//cdn1.zygames.com/qqsm/t1/s/" + src + ".png");
        //用require编译图片地址  之后可能放在static 文件下
          return "//cdn1.zygames.com/qqsm/t1/s/" + src + ".png";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.inner {
  width: 1200px;
  margin: 0 auto;
  padding-top: 1px;
}
.bcWarp {
  background: url("https://cdn1.zygames.com/qqsm/Public/img/version/bg5.jpg") no-repeat top center;
  height: 1001px;
  position: relative;
  min-width: 1200px;
  .title {
    padding-top: 66px;
    position: relative;
  }
  h2 {
    color: #ffdb8d;
    font-size: 42px;
    margin-left: 508px;
    text-align: left;
    margin-top: -40px;
  }
  .bc {
    padding-top: 28px;
    height: 320px;
    li {
      padding-right: 20px;
      width: 280px;
      height: 297px;
      float: left;
      position: relative;
      img {
        display: inline-block;
        margin-top: 121px;
        margin-left: 20px;
        width: 240px;
        height: 135px;
      }
      .dates {
        font-size: 14px;
        color: #ffd98a;
        position: absolute;
        top: 39px;
        left: 60px;
      }
      .names {
        font-size: 14px;
        color: #ffc958;
        position: absolute;
        top: 250px;
        left: 28px;
        width: 240px;
        text-align: center;
        &.zsbc {
          line-height: 1.5;
          font-size: 12px;
        }
      }
    }
    li:nth-child(1) {
      background: url("https://cdn1.zygames.com/qqsm/Public/img/version/bc-0.png") no-repeat;
      height: 309px;
      p {
        color: #64baff;
      }
    }
    li:nth-child(2) {
      background: url("https://cdn1.zygames.com/qqsm/Public/img/version/bc-1.png") no-repeat;
      padding-left: 12px;
      .dates {
        // padding-left: 12px;
      }
      p {
        color: #ffd98a;
        padding-left: 12px;
      }
    }
    li:nth-child(3) {
      background: url("https://cdn1.zygames.com/qqsm/Public/img/version/bc-2.png") no-repeat;
      p {
        color: #f0d743;
      }
    }
    li:nth-child(4) {
      background: url("https://cdn1.zygames.com/qqsm/Public/img/version/bc-3.png") no-repeat;
      padding-right: 0;
      p {
        color: #d0d0d0;
      }
    }
  }
  .jx {
    height: 312px;
    margin: 50px auto 0;
    position: relative;
    &.jx2{
      width: 964px;
      background: url("https://cdn1.zygames.com/qqsm/Public/img/version/jx.png") no-repeat center top;
      dd{
        width: 442px; /*两个*/
      }
    }
    &.jx3{
      width: 1200px;
      background: url("https://cdn1.zygames.com/qqsm/Public/img/version/jx2.png") no-repeat center top;
      dd{
        width: 349px; /*三个*/
        padding: 75px 20px 0 20px; /*三个*/
      }
    }
    &.jx4{
      width: 1200px;
      background: url("https://cdn1.zygames.com/qqsm/Public/img/version/jx4.png?1") no-repeat center top;
      dd{
        width: 256px; /*三个*/
        padding: 75px 7px 0 30px; /*三个*/
      }
    }
    dd {
      float: left;
      padding: 75px 0 0 32px;
      color: #28cac4;
      font-size: 16px;
      img {
        display: inline-block;
        width: 240px;
        height: 135px;
        // padding: 15px 30px;
        margin: 15px auto;
      }
    }
    dt {
      width: 280px;
      position: absolute; left: 50%; margin-left: -140px;
      text-align: center;
      &.jx-title {font-size:40px;font-weight:bold;top:0;color:#49ece8;margin-top:-12px;}
      &.jx-date {font-size: 16px;top: 47px;color: #28cac4;}
    }
  }
}
</style>
















// WEBPACK FOOTER //
// src/components/qqsmVersion_bc.vue